export default {
  getData: (state) => (datasetName) => {
    return state[datasetName] || {};
  }
};
